import { mapRequests, type RequestBuilder } from "@lernetz/request";
import type { SharedProps } from "./types";
import { get } from "svelte/store";
import { set, locale } from "@lernetz/svelte-translate";
import { page } from "@inertiajs/svelte";


export var sharedProps: SharedProps;

export function setupSharedProps() {
    let pageStore = get( page );
    sharedProps = pageStore.props.shared as SharedProps;

    requests = mapRequests( sharedProps.routes );

    set( sharedProps.currentLocale, sharedProps.lang );
    locale.set( sharedProps.currentLocale );

}

export var requests: {
    icons: RequestBuilder;
    api: {
        model: RequestBuilder;
    };
    assets: RequestBuilder;
    asset: {
        blob: RequestBuilder;
        convert: RequestBuilder;
        download: RequestBuilder;
    };
};
